// extracted by mini-css-extract-plugin
module.exports = {"container":"system-attention-container__3OXj4","text":"system-attention-text__21jrE","button":"system-attention-button__1Wibj"};